export const WT_API_URL_BASE = process.env.REACT_APP_API_WT_URL_BASE;
export const WT_API_URL = `${WT_API_URL_BASE}/v1`;
export const WT_API_URL_V2 = `${WT_API_URL_BASE}/v2`;

export const OAUTH_API_URL = process.env.REACT_APP_AUTH;
export const AUTH_URL = WT_API_URL_BASE;

// ======================================================
// WT-CATALOG
// ======================================================
export const CATALOGS_PATH = '/wt-catalog/values';
export const CATALOGS_PATH_V2 = '/wt-catalog';
export const SEPOMEX_PATH = '/wt-catalog/sepomex';

// ======================================================
// WT-LOAD
// ======================================================
export const LOAD_PATH = `${WT_API_URL_V2}/wt-load`;
export const FILE_DETAILS_PATH = `${WT_API_URL_V2}/wt-load/detail`;
export const LOG_PROCESS_PATH_V2 = `${WT_API_URL_V2}/wt-load/paged`;
export const LOG_PROCESS_GRUPED_PATH_V2 = `${WT_API_URL_V2}/wt-load/grouped`;
export const FILES_PATH_V2 = `${WT_API_URL_V2}/wt-load/upload`;
export const LOAD_BATCH = `${WT_API_URL_BASE}/wt-load-batch/api/v1`;

// ======================================================
// WT-PORTFOLIO
// ======================================================
export const MODEL_PORTFOLIO_PATH = `${WT_API_URL}/wt-portfolio/portfolio`;
export const STRATEGY_PATH = `${WT_API_URL}/wt-portfolio/strategy`;
export const STRATEGY_CLIENT_PATH = `${WT_API_URL}/wt-portfolio/client/accounts`;

// ======================================================
// WT-PORTFOLIO-REAL
// ======================================================
export const CLASSIFICATION_PATH = '/wt-portfolio-real/classification';
export const EMISORA_PATH = '/wt-portfolio-real/classification';
export const ISSUER_PATH = `${WT_API_URL}/wt-portfolio-real/classification/autocomplete/issuer`;
export const PORTFOLIO_REAL_PATH = '/wt-portfolio-real/portfolio';
export const DASHBOARD_PATH = '/wt-portfolio-real/portfolio/dashboard';
export const PORTFOLIO_POSITIONS_PATH = '/wt-portfolio-real/portfolio/header';
export const PORTFOLIO_TABLE_PATH = '/wt-portfolio-real/position';
export const PORTFOLIO_FUNDS_PATH = '/wt-portfolio-real/funds';
export const PORTFOLIO_EXCHANGES_PATH = '/wt-portfolio-real/banxico/exchanges';
export const ALERT_PATH = '/wt-portfolio-real/alert';
export const AUDIT_REPORT_PATH = '/wt-portfolio-real/audit-report';
export const CONCENTRATION_VIOLATION_PATH =
  '/wt-portfolio-real/concentration-violations';

// ======================================================
// WT-RETURNS
// ======================================================
export const PDF_DOCUMENT_PATH = '/wt-returns/inter-month/report';
export const YIELDS_PATH = '/wt-returns/returns-graphics';
export const INVESTMENT_PATH = `${WT_API_URL}/wt-returns/investment`;
export const FEE_PATH = `${WT_API_URL}/wt-returns/fee`;
export const CALCULATION_YIELDS_PATH = `${WT_API_URL}/wt-returns/returns/performance-retro-v2`;

// ======================================================
// WT-REPORT
// ======================================================
export const DOCUMENT_PATH = '/wt-report';
export const CLIENT_REPORTS_PATH = `${WT_API_URL}${DOCUMENT_PATH}/download/reports`;
export const BLACKLIST_REPORTS_PATH = `${WT_API_URL}${DOCUMENT_PATH}/restrincted`;
export const DASHBOARD_BALANCING_PATH = `${WT_API_URL}/wt-report/download/rebalance/excel`;

// ======================================================
// WT-REBALANCE
// ======================================================
export const BALANCING_PATH = `${WT_API_URL}/wt-rebalance/rebalance`;
export const BALANCING_COLLAPSE_PATH = `${WT_API_URL}/wt-rebalance/operation/collapse`;
export const BALANCING_REAL_TIME_PATH = `${WT_API_URL}/wt-rebalance/operation/realTime`;
export const BALANCING_DOWNLOAD_PATH = `${WT_API_URL}${DOCUMENT_PATH}/download/global/operations`;
export const VALUE_CONSTRAINT = `${WT_API_URL}/wt-rebalance/value-constraint`;
export const LIQUIDITY_CONSTRAINT = `${WT_API_URL}/wt-rebalance/liquidity-constraint`;
export const INSTRUMENT_CONSTRAINT = `${WT_API_URL}/wt-rebalance/instrument-constraint`;

// ======================================================
// WT-COMPLIANCE
// ======================================================
export const COMPLIANCE_PATH = `${WT_API_URL}/wt-compliance/compliance`;
export const COMPLIANCE_BLACKLIST_PATH = 'wt-compliance/compliance/black/list';
export const COMPLIANCE_ENGINE_PATH = `${WT_API_URL_BASE}/wt-compliance-engine/api/v1`;

// ======================================================
// SOCKET
// ======================================================
export const SOCKET_URL = `${WT_API_URL}/wt-websocket`;
